import * as React from "react";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { MetricGrid } from "@/components/dashboard/MetricGrid";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { useAnalyticsSnapshot } from "@/hooks/queries/useAnalytics";
import { appConfig } from "@/utils/config";

interface AnalyticsSnapshotPayload {
  profit_factor: number | null;
  expectancy: number | null;
  average_win: number | null;
  average_loss: number | null;
  risk: { recovery_factor: number } | null;
}

/** See PerformanceSummarySection - same `GET /api/v1/analytics` read applies here. */
export function PerformanceMetricsSection(): React.JSX.Element {
  const analyticsQuery = useAnalyticsSnapshot(appConfig.defaultPortfolioId);

  return (
    <StatusCard title="Performance Metrics">
      <QueryStateBoundary query={analyticsQuery}>
        {(payload) => {
          const snapshot = payload as unknown as AnalyticsSnapshotPayload;
          return (
            <MetricGrid
              metrics={[
                { label: "Profit Factor", value: snapshot.profit_factor },
                { label: "Expectancy", value: snapshot.expectancy },
                { label: "Average Win", value: snapshot.average_win },
                { label: "Average Loss", value: snapshot.average_loss },
                { label: "Recovery Factor", value: snapshot.risk?.recovery_factor ?? null },
              ]}
            />
          );
        }}
      </QueryStateBoundary>
    </StatusCard>
  );
}
